import "./styles/App.css";
import Dictionary from "./components/Dictionary";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App container">
      <Dictionary />
      <Footer />
    </div>
  );
}

export default App;
